
<portal to="drawer">
    <transition name="drawer" @enter="onEnter" @leave="onLeave" :css="false">
        <div v-if="isVisible" class="mobile-drawer-overlay" @click="handleOverlayClick">
            <div class="mobile-drawer" @click.stop ref="drawer">
                <div class="mobile-drawer-header" ref="header">
                    <div class="mobile-drawer-handle"></div>
                    <h3>{{ title }}</h3>
                    <button class="mobile-drawer-close" @click="close" :aria-label="closeLabel">
                        <i class="ri-close-line"></i>
                    </button>
                </div>
                <div
                    class="mobile-drawer-content"
                    ref="content"
                    :class="{ 'toolbar-variant': variant === 'toolbar' }"
                >
                    <slot></slot>
                </div>
            </div>
        </div>
    </transition>
</portal>
